import { useNavigate } from "react-router";
import React, { useState, useEffect } from "react";
import DgButton from "../DgButton";
import DgModal from "../DgModal";
import Swal from "sweetalert2";
import { getFromSession } from "../../utils/sessionUtils";
import { Person, Email, Phone } from "@mui/icons-material";
import "../../styles/sidebar.css";

function Sidebar({ data, role }) {
  const navigate = useNavigate();
  const [active, setActive] = useState("/");
  const [showAdvisorModal, setShowAdvisorModal] = useState(false);
  
  const advisorName = getFromSession("advisorName");
  const advisorOwner = getFromSession("advisorOwner");
  const advisorPhone = getFromSession("advisorPhone");
  
  // Formatear el correo ya que se recibe así:
  // USER#advisor#joseph.advisor@dgmxtech.com#39f9d90e-c071-70ab-03b3-e14b7b795d44
  const correo = advisorOwner ? advisorOwner.split('#')[2] : '';

  const devAlert = () => {
    Swal.fire({
      title: "Under Development",
      text: "Work in progress",
      icon: "warning",
    });
  };

  const handleContactAdvisor = () => {
    if (advisorPhone) {
      window.open(`https://wa.me/${advisorPhone}`, "_blank");
    } else {
      Swal.fire(
        "Oops",
        "It seems that this advisor hasn't completed his/her contact info, please reach out support.",
        "warning"
      );
    }
  };

  const handleShowAdvisorInfo = () => {
    setShowAdvisorModal(true);
  };

  useEffect(() => {
    setActive(window.location.pathname);
  }, []);

  return (
    <>
      <div className="sidebar">
        <div className="modules">
          {data.map((module) => (
            <div
              key={module.path}
              onClick={() => navigate(module.path)}
              className={
                "module " +
                (module.path == active ? "active" : "") +
                (module.value == "settings" ? " settings" : "")
              }
            >
              <div className="item">
                <img
                  src={
                    "/assets/icons/sidebar/" +
                    module.icon +
                    (module.path == active ? "-active" : "") +
                    ".svg"
                  }
                  alt=""
                  className="icon"
                />
                <span>{module.title}</span>
              </div>
            </div>
          ))}
        </div>
        
        {role === "customer" && (
          <div className="advisor-help">
            <div className="cont">
              <img
                src="/assets/illos/advisor-help.png"
                alt=""
                className="help-img"
              />
              <p className="description">
                Get in contact with a professional financial advisor to modify
                your investments profit
              </p>
              
              {/* Botón para mostrar información del advisor */}
              <DgButton
                category="primary"
                size="small"
                action={handleShowAdvisorInfo}
                text="View Advisor Info"
              />
              
              {/* Botón original para contactar */}
              <DgButton
                category="secondary"
                size="small"
                action={handleContactAdvisor}
                text="Contact Advisor"
              />
            </div>
          </div>
        )}
      </div>

      {/* Modal con fondo de color y texto blanco */}
      <DgModal 
        modalState={showAdvisorModal} 
        handleModalState={setShowAdvisorModal}
      >
        <div className="advisor-modal">
          {/* Header */}
          <div className="modal-header">
            <h2>Your Financial Advisor</h2>
            <p>Professional investment guidance</p>
          </div>

          {/* Contenido principal */}
          <div className="modal-body">
            <div className="advisor-info">
              
              <div className="info-card">
                <div className="icon-wrapper">
                  <Person />
                </div>
                <div className="info-content">
                  <span className="info-label">Full Name</span>
                  <span className="info-value">
                    {advisorName || 'Not available'}
                  </span>
                </div>
              </div>

              <div className="info-card">
                <div className="icon-wrapper">
                  <Email />
                </div>
                <div className="info-content">
                  <span className="info-label">Email Address</span>
                  <span className="info-value">
                    {correo || 'Not available'}
                  </span>
                </div>
              </div>

              <div className="info-card">
                <div className="icon-wrapper">
                  <Phone />
                </div>
                <div className="info-content">
                  <span className="info-label">Phone Number</span>
                  <span className="info-value">
                    {advisorPhone || 'Not available'}
                  </span>
                </div>
              </div>

            </div>
          </div>

          {/* Footer con botón */}
          <div className="modal-footer">
            <DgButton
              category="primary"
              size="large"
              action={handleContactAdvisor}
              text="Contact via WhatsApp"
            />
          </div>
        </div>
      </DgModal>
    </>
  );
}

export default Sidebar;
